import React from 'react'
import { ArrowLeft } from "react-feather";

const ApiReference = () => {
    return (
        <div className="mt-16 px-32">
        <a href="/#"
         className="mb-3 focus:outline-none -ml-3 backButtton flex hover:bg-blue-200 items-center px-4 py-2 rounded-md text-blue-700"
         style={{width:"fit-content"}}
       >
         <ArrowLeft size="16" className="mr-2" />
         <span className="text-sm">Back to Help Center</span>
       </a>
       <h1 className="text-3xl font-bold text-gray-800">API Reference Guide</h1>
       <div className="my-16 text-gray-600">
         <div className="bg-white flex h-64 items-center justify-center overflow-hidden p-10 rounded-lg shadow shadow-lg text-5xl text-gray-600">
           <h1>Coming Soon</h1>
         </div>
       </div>
     </div>
    )
}

export default ApiReference
